import React from 'react'

const Navbutton = ({category, className, onChangeCategory, link}) => {
	return (
		<button className={className} 
		onClick={()=>onChangeCategory(category)}>
			<a href={link} className="nav_button">{category}
			</a>
			
		</button> 
	)
}

export default Navbutton